import { useState, useEffect } from 'react';
import TabPanel from './TabPanel';
import { invokeGetService, setReRender, setTabOnFocus, invokePostService, setDashboardRefresh, setFocusElement } from '../../store/global/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getTabOnFocus } from '../../store/global/selectors';
import { Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { handleSnackBar } from '../../store/global/actions';
import { toggleRightDrawer } from '../../store/global/actions';
import { getElementOnFocus } from '../../store/global/selectors';
import EventSelector from '../molecules/dashboardBuilder/EventSelector';
import Button from '@material-ui/core/Button';
import TableActions from '../molecules/dashboardBuilder/TableActions';
import { getViews } from '../../store/views/selectors';
import { findSelectedSchema } from '../../services/builder/util';
import NoItemFoundAlert from '../molecules/alerts/NoItemFoundAlert';
import { controlTypes, actionRequiredTypes } from '../../config/fields';
import GaugeRangeSelector from '../molecules/dashboardBuilder/GaugeRangeSelector';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import List from '@material-ui/core/List';
import { getRightDrawerStatus } from '../../store/global/selectors';
import { editView } from "../../store/views/actions";
import { getDetailsFromUrl } from '../../services/blueprint'
import { useHistory } from "react-router-dom";
import WidgetForm from '../molecules/dashboardBuilder/WidgetForm';
import Fields from '../molecules/dashboardBuilder/Fields';
import MappingSelector from '../molecules/dashboardBuilder/MappingSelector';
import TableRowActions from '../molecules/dashboardBuilder/TableRowActions';
import TableRowHyperlink from '../molecules/dashboardBuilder/TableRowHyperlink';
import { updateViewSchema } from '../../utils/DashboardBuilder';
import WidgetSelector from '../molecules/dashboardBuilder/WidgetSelector';
import { useBottomDrawer } from '../../hooks/useBottomDrawer';


export default function ViewUI({ element }) {
  const dispatch = useDispatch();
  const tabOnFocus = useSelector(getTabOnFocus);
  const elementOnFocus = useSelector(getElementOnFocus);
  const selectedView = useSelector(getViews);
  const rightDrawerStatus = useSelector(getRightDrawerStatus);
  const history = useHistory();

  const [action, setAction] = useState(0);
  // const [clusterlets, setClusterlets] = useState([]);

  const selectedChild = findSelectedSchema({ schemas: selectedView?.view_schema, id: element.id });
  const { slug, blueprintId } = getDetailsFromUrl();

  const [rowLevelActions, setRowLevelActions] = useState([]);
  const [tableLevelActions, setTableLevelActions] = useState([]);
  const [selectedWidget, setSelectedWidget] = useState(null);
  const [openTypeSelectForm, setTypeSelectForm] = useState(!element.id && !selectedWidget)
  const {setTabConfig, activeTab, setActiveTab} = useBottomDrawer()

  const isInheritedChild = selectedChild?.viewCopy !== undefined && selectedChild?.viewCopy === true ? true : false;

  const detailsBC = [
    { label: !openTypeSelectForm ? `Widget` : 'Select Widget', url: null },
  ];


  if (elementOnFocus?.name && !openTypeSelectForm) {
    detailsBC.push({ label: elementOnFocus.name, url: null })
  }

  if (selectedWidget?.title && !openTypeSelectForm) {
    detailsBC.push({ label: selectedWidget?.title, url: null })
  }

  useEffect(() => {
    setActiveTab(tabOnFocus);
    // loadClusterlets();

  }, [tabOnFocus]);

  useEffect(() => {
    updateTableOperations();
  }, [action]);


  const updateTableOperations = () => {
    const rowLevelActionsArray = selectedChild?.children.find((child) => child.type === 'drop-down') ? selectedChild?.children.find((child) => child.type === 'drop-down')?.children : [];
    setRowLevelActions(rowLevelActionsArray);

    const tableLevelActionsArray = selectedChild?.tableactions !== undefined ? selectedChild.tableactions : [];
    setTableLevelActions(tableLevelActionsArray);
  }
  // const loadClusterlets = () => {
  //   dispatch(invokeGetService('getBlueprintConstructs', []))
  //     .then((response) => {
  //       if (response?.status) {
  //         setClusterlets(response?.data?.clusterlets);
  //       }
  //     })
  // }

  const onCompletion = (type, action) => {
    if (action !== undefined) {
      switch (action) {
        case 'add':
          dispatch(handleSnackBar({ open: true, message: `${type} created`, severity: 'success' }));
          break;
        case 'edit':
          dispatch(handleSnackBar({ open: true, message: `${type} updated`, severity: 'success' }));
          break;

        case 'delete':
          dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: 'success' }));
          break;
        default: 
          break;
      }
      setSelectedWidget(null);
      setAction({});
    }
  };

  const onTableOperationCompletion = (type, action) => {
    if (action != undefined) {
      switch (action) {
        case 'add':
          dispatch(handleSnackBar({ open: true, message: `${type} created`, severity: 'success' }));
          break;
        case 'edit':
          dispatch(handleSnackBar({ open: true, message: `${type} updated`, severity: 'success' }));
          break;
        case 'delete':
          dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: 'success' }));
          break;
        default: 
          break;
      }
    }
    setAction({})
  }

  const onClose = () => {
    dispatch(setFocusElement(null));
    setAction({});
    setSelectedWidget(null);
  };

  const handleViewUpdate = (saveData, feedBack) => {
    dispatch(invokePostService('updateView', { view: saveData }, [selectedView._id])).then(response => {
      if (response.status === true) {
        dispatch(editView(saveData));
        dispatch(handleSnackBar({ open: true, message: feedBack, severity: 'success' }));
      } else {
        if (response.code === 255) {
          history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
          dispatch(setReRender());
          if (rightDrawerStatus == true) dispatch(toggleRightDrawer());
        }
      }
    })
  }


  const onDragRowOperationEnd = (item) => {
    // Check if the item was dropped outside the list
    if (!item.destination) {
      return;
    }
    const reorderedItems = Array.from(rowLevelActions);
    const [removed] = reorderedItems.splice(item.source.index, 1);
    reorderedItems.splice(item.destination.index, 0, removed);

    const actionField = selectedChild?.children.find((child) => child.type == 'drop-down');
    if (actionField) {
      setRowLevelActions(reorderedItems);
      actionField.children = reorderedItems;
      dispatch(setDashboardRefresh({ type: "widget", action: "edit", entity: selectedChild }));
      const updatedView = updateViewSchema(selectedView, 'edit', { id: selectedChild.id, updatedData: selectedChild });
      handleViewUpdate(updatedView, "Table operation reordered");
    }
  }

  const onDragTableOperationEnd = (item) => {
    // Check if the item was dropped outside the list
    if (!item.destination) {
      return;
    }
    const reorderedItems = Array.from(tableLevelActions);
    const [removed] = reorderedItems.splice(item.source.index, 1);
    reorderedItems.splice(item.destination.index, 0, removed);
    setTableLevelActions(reorderedItems);
    if (selectedChild?.tableactions) {
      selectedChild.tableactions = reorderedItems;
    }
    dispatch(setDashboardRefresh({ type: "widget", action: "edit", entity: selectedChild }));
    const updatedView = updateViewSchema(selectedView, 'edit', { id: selectedChild.id, updatedData: selectedChild });
    
    handleViewUpdate(updatedView, "Table operation reordered");

  }


  useEffect(() => {
    const tabs = [
      {
        label: "Widget"
      }
    ]

    if(!isInheritedChild){
      tabs.push(
        {
          label: "Data Source",
          isDisabled: elementOnFocus.action === 'create'
        },
       
      )
    }

    tabs.push(
      {
        label: "Fields",
        isDisabled: elementOnFocus.action === 'create'
      }
    )

    if((actionRequiredTypes.includes(selectedChild?.type) || controlTypes.includes(selectedChild?.type) || selectedChild?.type === "chat")){
      tabs.push(
        {
          label: actionRequiredTypes.includes(selectedChild?.type) ? 'Table Operation' : 'Operation',
          isDisabled: elementOnFocus.action === 'create'
        }
      )
    }

    if(actionRequiredTypes.includes(selectedChild?.type)){
      tabs.push(
        {
          label: "Row Operation",
          isDisabled: elementOnFocus.action === 'create' || selectedChild?.type !== 'table'
        }
      )
    }

    if(selectedChild?.type === 'gauge'){
      tabs.push({label: "Ranges"})
    }
    setTabConfig(tabs)
  },[elementOnFocus, isInheritedChild])

  useEffect(() => {
    setAction({})
  }, [activeTab])


  return (
    <>
      {/* <AppBar position="static">
        <Tabs
          value={openTab}
          onChange={(e, v) => {
            dispatch(setTabOnFocus(v));
            setOpenTab(v);
            setAction({});
          }}
          aria-label="simple tabs example">
          <Tab label="Widget" />
          {!isInheritedChild && <Tab label="Data Source" disabled={elementOnFocus.action === 'create' ? true : false} />}
          {!isInheritedChild && <Tab label="Fields" disabled={elementOnFocus.action === 'create' ? true : false} />}
          {(actionRequiredTypes.includes(selectedChild?.type) || controlTypes.includes(selectedChild?.type) || selectedChild?.type === "chat") && <Tab label={actionRequiredTypes.includes(selectedChild?.type) ? 'Table Operation' : 'Operation'} disabled={elementOnFocus.action === 'create' ? true : false} />}
          {actionRequiredTypes.includes(selectedChild?.type) && <Tab label="Row Operation" disabled={elementOnFocus.action === 'create' || selectedChild?.type != 'table'} />}
          {selectedChild?.type === 'gauge' && <Tab label="Ranges" />}
        </Tabs>
      </AppBar> */}

      {/*
        -----------------------------Panels of the tabs-----------------------
        1- Create UI Widget panel
        2- Mapping selector Tab
        3- Fields tab
        4- Conditional Range tab for Gauge
        5- Conditional Operation tab
        6- Conditional Row operation tab
      */}

      <TabPanel value={activeTab} index={0}>
          {
            !openTypeSelectForm &&
            <>
              <Grid container direction={'row'} spacing={2}>
                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant="contained"
                      onClick={() => setTypeSelectForm(true)}
                      style={{
                        padding: '0 10px',
                        paddingTop: 0,
                        lineHeight: '30px',
                        height: 'max-content',
                        outline: 'none',
                        border: 'none',
                        textTransform: 'initial'
                      }}>
                      Change Type
                    </Button>
                  </Grid>
              </Grid>
            </>
          }


        {/* parentID, onClose, id, action, rootId */}
        {
          openTypeSelectForm ?
            <WidgetSelector
              selectedWidget={selectedWidget}
              setSelectedWidget={setSelectedWidget}
              view={selectedView}
              setTypeSelectForm={setTypeSelectForm}
            />
            :
            <WidgetForm
              id={element.id}
              type={elementOnFocus.type}
              action={elementOnFocus.action}
              onCompletion={onCompletion}
              onClose={onClose}
              parentID={elementOnFocus.parentID}
              rootId={selectedView?._id}
              selectedWidget={selectedWidget}
              setSelectedWidget={setSelectedWidget}
            />
        }
      </TabPanel>


      {/*Tab panel for 'datasource mapping'  */}
      {!isInheritedChild && 
        <TabPanel value={activeTab} index={1}>
          <MappingSelector parentID={elementOnFocus.parentID} id={elementOnFocus.id} type={elementOnFocus.type} action={elementOnFocus.action} onClose={onClose} rootId={elementOnFocus.rootId} onCompletion={onCompletion} />
        </TabPanel>
      }

        <TabPanel value={activeTab} index={isInheritedChild ? 1 : 2}>
          <Fields selectedWidget={selectedChild} />
        </TabPanel>

      {/* Tab panel for 'ranges in gauges' */}
      {selectedChild?.type === 'gauge' ? (
        <TabPanel value={activeTab} index={isInheritedChild ? 2 : 3}>
          <GaugeRangeSelector selectedWidget={selectedChild} onCompletion={onCompletion} onClose={onClose}/>
        </TabPanel>
      ) : (

        // Tab panel for 'table actions'
        <TabPanel value={activeTab} index={isInheritedChild ? 2 : 3}>
          <Grid container direction={'row'} spacing={2}>
            {Object.keys(action).length === 0 && actionRequiredTypes.includes(selectedChild?.type) && (
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>

                <Tooltip title="Create button">
                  <span>
                    <Button id="create-action" onClick={(e) => setAction({ action: 'create_table_button' })} color="primary" variant="contained" style={{ marginLeft: 10, marginBottom: 10 }}>
                      Add Operation
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
            )}
          </Grid>

          <DragDropContext onDragEnd={onDragTableOperationEnd}>
            <Droppable droppableId="items">
              {(provided) => (
                <List id="tableOperations" {...provided.droppableProps} ref={provided.innerRef}>
                  {Object.keys(action).length === 0 && selectedChild?.type === 'table' && tableLevelActions.map((item, index) => {
                    return (
                      <Draggable key={item.id} draggableId={item.id} index={index} style={{ paddingRight: 0 }}>
                        {(provided) => (
                          <div {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            ref={provided.innerRef}>
                            <TableActions selectedWidget={selectedChild} key={item.id} tableAction={item} action={action} setAction={setAction} tableLevel={true} selectedId={element.id} index={index}>
                              <EventSelector noFloatButton key={item.id} id={element.id} action={elementOnFocus.action} onCompletion={onTableOperationCompletion} onClose={onClose} parentID={elementOnFocus.parentID} rootId={elementOnFocus.rootId} selectedSchema={item} index={index} />
                            </TableActions>
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </List>
              )}
            </Droppable>
          </DragDropContext>

          {Object.keys(action).length === 0 && tableLevelActions.length === 0 && actionRequiredTypes.includes(selectedChild?.type) && (
            <NoItemFoundAlert type={'buttons created'} />
          )}
          {(action.action === 'create_table_button' || controlTypes.includes(selectedChild?.type) || selectedChild?.type === "chat") && (
            <EventSelector id={element.id} action={elementOnFocus.action} forceCancel onCompletion={onTableOperationCompletion} onClose={() => setAction({})} parentID={elementOnFocus.parentID} rootId={elementOnFocus.rootId} />
          )}
        </TabPanel>
      )}



      {/* Tab panel for 'table row level operations'  */}
      <TabPanel value={activeTab} index={isInheritedChild ? 3 : 4}>
        <Grid container direction={'row'} spacing={2}>
          {Object.keys(action).length === 0 && selectedChild?.type === 'table' && (
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title="Add Hyperlink">
                <span>
                  <Button id="add-hyperlink" onClick={(e) => setAction({ action: 'add_rowlevel_hyperlink' })} color="primary" variant="contained" style={{ marginBottom: 10 }}>
                    Add Hyperlink
                  </Button>
                </span>
              </Tooltip>

              <Tooltip title="Create button">
                <span>
                  <Button id="create-row-action" onClick={(e) => setAction({ action: 'add_rowlevel_operation' })} color="primary" variant="contained" style={{ marginLeft: 10, marginBottom: 10 }}>
                    Add Operation
                  </Button>
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>
        <DragDropContext onDragEnd={onDragRowOperationEnd}>
          <Droppable droppableId="items">
            {(provided) => (
              <List id="rowOperations" {...provided.droppableProps} ref={provided.innerRef}>
                {Object.keys(action).length === 0 && selectedChild?.type === 'table' && rowLevelActions.map((item, index) => {
                  return (
                    <Draggable key={item.id} draggableId={item.id} index={index} style={{ paddingRight: 0 }}>
                      {(provided) => (
                        <div {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}>
                          <TableActions selectedWidget={selectedChild} tableAction={item} action={action} setAction={setAction} selectedId={element.id} index={index}>
                            {item.type === "button" && (
                              <TableRowActions noFloatButton selectedWidget={selectedChild} id={element.id} action={elementOnFocus.action} onCompletion={onTableOperationCompletion} onClose={() => setAction({})} parentID={elementOnFocus.parentID} rootId={elementOnFocus.rootId} selectedSchema={item} index={index} />
                            )}
                            {item.type === "string" && (
                              <TableRowHyperlink noFloatButton selectedWidget={selectedChild} id={element.id} action={elementOnFocus.action} onCompletion={onTableOperationCompletion} onClose={() => setAction({})} parentID={elementOnFocus.parentID} rootId={elementOnFocus.rootId} selectedSchema={item} index={index} />
                            )}
                          </TableActions>
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </List>
            )}

          </Droppable>
        </DragDropContext>


        {Object.keys(action).length === 0 && rowLevelActions.length === 0 && <NoItemFoundAlert type={'buttons created'} />}
        {action.action === 'add_rowlevel_operation' && <TableRowActions forceCancel selectedWidget={selectedChild} id={element.id} action={elementOnFocus.action} onCompletion={onTableOperationCompletion} onClose={() => setAction({})} parentID={elementOnFocus.parentID} rootId={elementOnFocus.rootId} />}
        {action.action === 'add_rowlevel_hyperlink' && <TableRowHyperlink forceCancel selectedWidget={selectedChild} id={element.id} action={elementOnFocus.action} onCompletion={onTableOperationCompletion} onClose={() => setAction({})} parentID={elementOnFocus.parentID} rootId={elementOnFocus.rootId} />}
      </TabPanel>
    </>
  );
}